// extracted by mini-css-extract-plugin
export var bottom = "style-module--bottom--8c11c";
export var desc = "style-module--desc--47ffc";
export var screen1 = "style-module--screen1--c6f21";
export var sub = "style-module--sub--02866";
export var time = "style-module--time--ecb06";
export var titles = "style-module--titles--c214b";
export var top = "style-module--top--f9c9f";
export var type = "style-module--type--c804a";